import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const location = useLocation();
  const { pathname, hash, state } = location;

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // If another part of the app recently requested a section scroll (from subpages),
    // suppress automatic "scroll to top" behavior for a short window.
    if (typeof window !== 'undefined' && window.__suppressTopScroll) {
      return;
    }

    if (hash) {
      const targetId = hash.replace('#', '');
      const targetElem = document.getElementById(targetId);

      if (targetElem) {
        targetElem.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    if (state?.scrollToSection) {
      // Home-page section targeting (from subpages) will handle its own scroll.
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash, state?.scrollToSection]);

  return null;
}
